// Import
import moment from "moment";
import { getTranslation } from "Utils/getTranslation"
import { isObjectV2 } from "Utils/global.js"
export const monthNameListEN = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]

export const monthNameListFR = [
  "Janvier",
  "Février",
  "Mars",
  "Avril",
  "Mai",
  "Juin",
  "Juillet",
  "Aout",
  "Septembre",
  "Octobre",
  "Novembre",
  "Décembre",
]

export function getMonthNameWithMonthNumber(numberMonth, languageId) {
  var languageIdToUse = typeof languageId === "string" ? parseInt(languageId) : languageId
  if (numberMonth < 0 && numberMonth >= 12) {
    console.error("The Month number is not in correct range")
    return "undefined"
  }
  if (languageIdToUse > 1 || languageIdToUse === 0 || languageIdToUse === undefined) {
    return monthNameListEN[numberMonth]
  } else if (languageIdToUse === 1) {
    return monthNameListFR[numberMonth]
  }

  return monthNameListEN[numberMonth]
}

export const addZeroBeforeNumber = number => {
  return number < 10 ? `0${number}` : number
}

export function getDDMMYYYYSpaceTimeFromTimestamp(timestampDate) {
  var date = new Date(timestampDate * 1000)

  var dateNumber = addZeroBeforeNumber(date.getDate())
  var month = addZeroBeforeNumber(date.getMonth() + 1)
  var year = addZeroBeforeNumber(date.getFullYear())
  var hours = addZeroBeforeNumber(date.getHours())
  var minutes = addZeroBeforeNumber(date.getMinutes())

  return `${dateNumber}/${month}/${year} ${hours}:${minutes}`
}

export function getDDMMYYYYFromTimestamp(timestampDateInSecond) {
  var date = new Date(timestampDateInSecond * 1000)

  var dateNumber = addZeroBeforeNumber(date.getDate())
  var month = addZeroBeforeNumber(date.getMonth() + 1)
  var year = addZeroBeforeNumber(date.getFullYear())

  return `${dateNumber}/${month}/${year}`
}

export const getDateDDMonthYYHHMM = (lastUpdate, languageId) => {
  var dateToUse = new Date(lastUpdate)
  const dayOfTheMonth = addZeroBeforeNumber(dateToUse.getDate())
  const monthNumber = dateToUse.getMonth()
  const monthName = getMonthNameWithMonthNumber(monthNumber, languageId)
  const monthNameThereCharac = monthName.substring(0, 3)
  const yearYYYY = dateToUse.getFullYear()
  const yearYY = yearYYYY % 100

  var hours = addZeroBeforeNumber(dateToUse.getHours())
  var minutes = addZeroBeforeNumber(dateToUse.getMinutes())

  var finalText = `${dayOfTheMonth} ${monthNameThereCharac} ${yearYY} ${hours}:${minutes}`
  return finalText
}
// Différence de nombre de jour entre la date du jour et celle sélectionnée
export const numberDayBetweenDateAndNow = date => {
  const dateDay = moment()
  const dateUpdate = moment(date)
  const diffDay = dateDay.diff(dateUpdate, "days")

  return diffDay
}

// Affichage nombre de jour ou date de mise a jour
export const numberDayOrDateUpdate = (date, numberDayLimit, languageId) => {
  const trad = getTranslation(languageId)
  const nbDay = numberDayBetweenDateAndNow(date)

  const finalResult =
    nbDay > numberDayLimit
      ? trad["UPDATED_THE"] + " " + getDateDDMonthYYHHMM(date, languageId)
      : trad["MAJ_DATACATALOGUE"] + " " + nbDay + " " + trad["DAY_DATACALOGUE"]

  return finalResult
}

export const getTimestampFromDDMMYYYY = date => {
  if (date) {
    const dateSplit = date.split("/")
    const dateFormated = new Date(dateSplit[2], dateSplit[1] - 1, dateSplit[0])
    const timeStamp = dateFormated.getTime()
    return timeStamp
  } else {
    return date
  }
}
// Transforme date MOMENT en format "DD/MM/YYYY"
export const getMomentFromDDMMYYYY = date => {
  if (date) {
    const dateFormat = moment(date).format("DD/MM/YYYY")
    const checkDate = date !== "" ? dateFormat : ""

    return checkDate
  } else {
    return ""
  }
}
// Transforme date DD/MM/YYYY" en format "MM/DD/YYYY"
export const getDDMMYYYYFromMMDDYYYY = date => {
  if (date) {
    const dateSplit = date.split("/")
    const newDate = `${dateSplit[1]}/${dateSplit[0]}/${dateSplit[2]}`
    return newDate
  } else {
    return ""
  }
}

// Transforme date YYYY/MM/DD" en format "DD/MM/YYYY"
export const getYYYYMMDDFromDDMMYYYY = (date, separator = "/") => {
  if (date) {
    const dateSplit = date.split(separator)
    const newDate = `${dateSplit[2]}${separator}${dateSplit[1]}${separator}${dateSplit[0]}`
    return newDate
  } else {
    return ""
  }
}

// Transforme date "DD/MM/YYYY" en format "YYYY/MM/DD"
export const getDDMMYYYYFromYYYYMMDD = (date, separator = "/", newSeparator = "/") => {
  if (date) {
    const dateSplit = date.split(separator)
    const newDate = `${dateSplit[2]}${newSeparator}${dateSplit[1]}${newSeparator}${dateSplit[0]}`
    return newDate
  } else {
    return ""
  }
}

export const getDateDDMMYYYYFromNanoSecLongNumber = nanoSecLongNumb => {
  if (isObjectV2(nanoSecLongNumb) && nanoSecLongNumb.hasOwnProperty("$numberLong")) {
    return getDateDDMMYYYYFromNanoSec(nanoSecLongNumb.$numberLong)
  }
  return getDateDDMMYYYYFromNanoSec(nanoSecLongNumb)
}

export const getDateDDMMYYYYFromNanoSec = nanoSec => {
  var nanoSecToUse = 0
  if (nanoSec !== undefined && typeof nanoSec === "number") {
    nanoSecToUse = nanoSec
  }
  const ONE_BILLON = 1000 * 1000 * 1000
  const second = nanoSecToUse / ONE_BILLON
  var date = getDDMMYYYYFromTimestamp(second)
  return date
}

export const getActualDateInNanoSec = () => {
  const ONE_MILLON = 1000 * 1000
  const milliSecond = Date.now()
  const nanoSec = milliSecond * ONE_MILLON
  return nanoSec
}

export const dateIsBetween = (timeStampToTest, [timeStamp1, timeStamp2]) => {
  return timeStamp1 <= timeStampToTest && timeStampToTest <= timeStamp2
}

export const getDateObjectfromDDMMYYYY = date => {
  if (!date) return ""
  const currentDate = new Date()
  const { currentHours, currentMinutes } = {
    currentHours: currentDate.getHours(),
    currentMinutes: currentDate.getMinutes(),
  }
  if (typeof date !== "string") return new Date(0, 0, 0, hours, minutes)
  const dateSplit = date.split("/")

  const day = parseInt(dateSplit[0])
  const month = parseInt(dateSplit[1]) - 1
  const year = parseInt(dateSplit[2])

  return new Date(year, month, day, currentHours, currentMinutes)
}

export const getDateYYYYMMDDFromISO = isoDate => {
  if (!isoDate) return ""
  const date = new Date(isoDate)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, "0")
  const day = String(date.getDate()).padStart(2, "0")
  const formattedDate = `${year}-${month}-${day}`
  return formattedDate
}

// We take a previous date in french format days/month/years and add number of days
// Return a date in french format
export const addDaysToDate = (previousDate, daysToAdd) => {
  if (!previousDate) return ""
  if (!daysToAdd) return previousDate
  const [day, month, year] = previousDate.split("/").map(Number)
  const previousDateIso = new Date(year, month - 1, day)
  const daysToAddNumber = parseInt(daysToAdd)
  const newDateTimeStamp = previousDateIso.setDate(previousDateIso.getDate() + daysToAddNumber)
  const newDateFrenchFormat = new Date(newDateTimeStamp).toLocaleDateString("fr")
  return newDateFrenchFormat
}

export const getLocaleDateFromIso = (isoDate, showHours = false) => {
  if (!isoDate) return ""
  let options = { year: "numeric", month: "long", day: "numeric" }
  if (showHours) options = { ...options, hour: "2-digit", minute: "2-digit" }
  const localDate = new Date(isoDate).toLocaleDateString(undefined, options)
  return localDate === "Invalid Date" ? isoDate : localDate
}

export const isIsoDate = str => {
  var pattern = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}.\d{3}$/
  return pattern.test(str)
}
